// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__IgFvN","heading":"Privacy_heading__kiSrA","subheading":"Privacy_subheading__MJUaR","bulletPoints":"Privacy_bulletPoints__I8lqU"};